export default class RenderingState {
  private dirtyBit = true;
  private currentTransform;
  private dirtyBitActiveUntil = 0;
  private lastZoomLevel = null;
  private _hasZoomedIn = false;
  private _hasZoomedOut = false;
  private _hasPanned = false;

  constructor() {
    this.dirtyBit = false;
    this.currentTransform = null;
  }

  getCurrentTransform() {
    return this.currentTransform;
  }

  hasZoomedIn() {
    //returns if last action was zoom-in
    return this._hasZoomedIn;
  }

  hasZoomedOut() {
    //returns if last action was zoom-out
    return this._hasZoomedOut;
  }

  hasPanned() {
    //returns if last action was panning
    return this._hasPanned;
  }

  setCurrentTransform(currentTransform) {
    if (!this.lastZoomLevel) {
      this.lastZoomLevel = currentTransform.k;
    } else {
      this._hasZoomedIn = false;
      this._hasZoomedOut = false;
      this._hasPanned = false;
      if (this.lastZoomLevel < currentTransform.k) {
        this._hasZoomedIn = true;
      } else if (this.lastZoomLevel > currentTransform.k) {
        this._hasZoomedOut = true;
      } else {
        this._hasPanned = true;
      }

      this.lastZoomLevel = currentTransform.k;
    }

    this.currentTransform = currentTransform;
    this.setDirtyBit(true);
  }

  setDirtyBit(value) {
    this.dirtyBit = value;
  }

  getDirtyBit() {
    if (this.dirtyBit) {
      return this.dirtyBit;
    } else if (this.dirtyBitActiveUntil) {
      const d = new Date();
      if (d.getTime() < this.dirtyBitActiveUntil) {
        return true;
      } else {
        this.dirtyBitActiveUntil = null;
        return false;
      }
    }

    return false;
  }

  // sets dirty bit to true for the time of an animation
  setDirtyBitUntil(time) {
    this.dirtyBitActiveUntil = time;
  }

  getDirtyBitActiveUntil() {
    return this.dirtyBitActiveUntil;
  }

  extendDirtyBitActiveBy(ms) {
    const finishTime = new Date().getTime() + ms;
    if (finishTime > this.dirtyBitActiveUntil) {
      this.dirtyBitActiveUntil = finishTime;
    }
  }
}
